export class LoginResponseModel {
  constructor(
    public access_token: string,
    public token_type: string,
    public user_role: string
  ) {}
}
